/*
 * Copyright (c) 2018. Rezo Zero
 *
 * This file is part of Supreme NTM.
 *
 * Supreme NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file FacebookBlock.js
 * @author Ambroise Maupate <ambroise@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {AbstractBlock} from 'starting-blocks'
import $ from 'jquery'
import * as log from 'loglevel'

export default class FacebookBlock extends AbstractBlock {
    init () {
        super.init()
        log.debug('\t📺 Facebook listing')

        if (!window.fetch) {
            throw new Error('window.fetch is not supported by your browser.')
        }

        this.postsOptions = {
            fields: 'created_time,full_picture,message,permalink_url,name,type,shares',
            access_token: window.TEMP.facebookAccessToken
        }
        this.postsEndPoint =
            'https://graph.facebook.com/' +
            window.TEMP.graphApiVersion +
            '/' +
            window.TEMP.facebookPageId +
            '/posts?' +
            $.param(this.postsOptions)

        this.pageOptions = {
            fields: 'name,picture,description,general_info,page_token',
            access_token: window.TEMP.facebookAccessToken
        }
        this.pageEndPoint =
            'https://graph.facebook.com/' +
            window.TEMP.graphApiVersion +
            '/' +
            window.TEMP.facebookPageId +
            '?' +
            $.param(this.pageOptions)

        Promise.all([
            this.fetchPageApi(),
            this.fetchPostApi()
        ]).then(results => {
            this.pageInformation = JSON.parse(results[0])
            this.render(JSON.parse(results[1]).data)
        })
        /* this.fetchPostApi().then(data => {
            const jsonData = JSON.parse(data)
            this.render(jsonData.data)
        }) */
    }

    fetchPageApi () {
        return new Promise((resolve, reject) => {
            window.fetch(this.pageEndPoint, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Referer': window.location.origin,
                    'credentials': 'same-origin'
                },
                cache: 'default'
            }).then(res => {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.text())
                }
                const err = new Error(res.statusText || res.status)
                reject(err)
            }).catch(err => {
                reject(err)
            })
        })
    }

    fetchPostApi () {
        return new Promise((resolve, reject) => {
            window.fetch(this.postsEndPoint, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Referer': window.location.origin,
                    'credentials': 'same-origin'
                },
                cache: 'default'
            }).then(res => {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.text())
                }
                const err = new Error(res.statusText || res.status)
                reject(err)
            }).catch(err => {
                reject(err)
            })
        })
    }

    render (contents) {
        for (const post of contents) {
            const date = window.moment(post.created_time).toDate()
            const monthOptions = { month: 'long', day: 'numeric' }
            const yearOptions = { year: 'numeric' }
            const template = `
<div class="facebook-post row" id="facebook-post-${post.id}" data-youtube-id="${post.id}">
        <div class="column column--1-2 column--padding-top">
            <div class="post-user">
                <img src="${post.full_picture}"
                     class="img-fluid"
                     alt="${post.name}">
            </div>
        </div>
        <div class="column column-1.2 column--padding-top">
            <div class="post-details">
                <div class="facebook-post__infos">
                    <img src="${this.pageInformation.picture.data.url}"
                         alt="${this.pageInformation.name}">
                    <div class="facebook-post__infos__text">
                        <h4>${this.pageInformation.page_token}</h4>
                        <time class="post-date date"
                              datetime="${post.created_time}">${date.toLocaleDateString('fr', monthOptions)} <span class="year">${date.toLocaleDateString('fr', yearOptions)}</span></time>
                    </div>
                </div>
                <p class="post-message">${post.message ? post.message : ''}</p>
                <a class="read-more" href="${post.permalink_url}" target="_blank" rel="nofollow">En savoir +</a>
            </div>
        </div>
    </div>`

            this.$cont.append(template)
        }
    }
}



// WEBPACK FOOTER //
// ./webpack/js/blocks/FacebookBlock.js